import React from 'react';
import { authService } from '../../services/auth.service';
import { useLanguage } from '../../context/LanguageContext';

const SessionExpiredModal = ({ open, onClose }) => {
  const { t } = useLanguage();
  
  if (!open) return null;

  const handleLogin = async () => {
    await authService.signOut(); // Clear any existing session
    onClose();
    window.location.href = '/login';
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
      <div className="bg-white rounded-lg p-8 max-w-md w-full mx-4">
        <h2 className="text-xl font-semibold mb-4">{t('sessionExpired')}</h2>
        <p className="text-gray-600 mb-6">
          {t('sessionExpiredMessage')}
        </p>
        <button
          className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 transition-colors"
          onClick={handleLogin}
        >
          {t('logIn')}
        </button>
      </div>
    </div>
  );
};

export default SessionExpiredModal;
